import { Spin } from 'antd';
import {
    createContext,
    FC,
    memo,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from 'react';
import commonService, { ApiOrganSchema } from 'services/autoCommonService';

interface ISystemData {
    organs: ApiOrganSchema[];
}

const SystemDataContext = createContext<ISystemData>({
    organs: [],
});

const useSystemData = () => useContext(SystemDataContext);

interface IProps {
    children?: ReactNode;
}

const SystemDataLoader: FC<IProps> = memo(({ children }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<ISystemData>({ organs: [] });

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const response = await commonService.getListOfOrgan();
            if (response.isSuccess) {
                setData({ organs: response.data || [] });
            }

            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <SystemDataContext.Provider value={data}>
            <Spin spinning={loading}>{children}</Spin>
        </SystemDataContext.Provider>
    );
});

SystemDataLoader.displayName = 'System Data Loader';

export { SystemDataLoader, useSystemData };
